import Navbar from '../../components/feature/Navbar';
import AboutHero from './components/AboutHero';
import Philosophy from './components/Philosophy';
import Differentiators from './components/Differentiators';
import Method from './components/Method';
import AboutCTA from './components/AboutCTA';
import Footer from '../home/components/Footer';

export default function About() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <AboutHero />
      <Philosophy />
      <Differentiators />
      <Method />
      <AboutCTA />
      <Footer />
    </div>
  );
}